import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'
import { useTranslation } from 'translations'

const CHECKOUT_PERFORMANCE_TAB_NODE_ID = '-C18gFCPnl'

interface CheckoutFunnelReportPageProps {
    accountSlug: string
}

const CheckoutFunnelReportPage = ({ accountSlug }: CheckoutFunnelReportPageProps) => {
    const { t } = useTranslation()
    return (
        <RedirectPage
            oldPageTitle={t('reports.checkoutFunnel.oldPageTitle')}
            newPageTitle={t('reports.redirect.marketingReport')}
            action={t('reports.redirect.isNowPartOf')}
            image={barcodesReportImage}
            link={`/account/${accountSlug}/reports/marketing#${CHECKOUT_PERFORMANCE_TAB_NODE_ID}`}
        />
    )
}

export default CheckoutFunnelReportPage
